// extracted by mini-css-extract-plugin
export default {"invisibleWithBorder":"ReposSelector-module__invisibleWithBorder__Iu2seUl","selected":"ReposSelector-module__selected__AyXSCQ_"};